// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2mWv0","dragIcon":"SortableItem_dragIcon__3hblX","disabled":"SortableItem_disabled__k8htX"};